import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import { useToast, TOAST_TYPES } from '../../../hooks/useToast';

const MockCredentialsHelper = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [copiedItem, setCopiedItem] = useState(null);
  const { showToast } = useToast();

  const mockAccounts = [
    {
      role: 'Admin',
      email: 'hawa.keita@ecomotech.gn',
      password: 'admin123',
      description: 'Full system access - User Management, All Modules',
      badge: 'Full Access'
    },
    {
      role: 'Manager',
      email: 'fodé.kaba@ecomotech.gn',
      password: 'manager123',
      description: 'Department Hub, Team Management, Budget Tracking, Task Assignment',
      badge: 'Manager'
    },
    {
      role: 'Staff Member',
      email: 'sékou.baldé@ecomotech.gn',
      password: 'staff123',
      description: 'Staff Workflow Center, Inventory View, Department View',
      badge: 'Staff'
    },
    {
      role: 'Viewer',
      email: 'sékouba.traoré@ecomotech.gn',
      password: 'viewer123',
      description: 'Read-only access - View Inventory, Financial Data, Reports',
      badge: 'View Only'
    }
  ];

  const copyToClipboard = (text, type) => {
    navigator.clipboard?.writeText(text)?.then(() => {
      const itemKey = `${text}-${type}`;
      setCopiedItem(itemKey);
      showToast(`${type === 'email' ? 'Email' : 'Password'} copied to clipboard!`, TOAST_TYPES.SUCCESS, 2000);
      
      // Reset the copied state after 2 seconds
      setTimeout(() => {
        setCopiedItem(null);
      }, 2000);
    }).catch(() => {
      showToast('Failed to copy to clipboard', TOAST_TYPES.ERROR, 2000);
    });
  };

  return (
    <div className="mt-6">
      <Button
        variant="ghost"
        size="sm"
        onClick={() => setIsExpanded(!isExpanded)}
        iconName={isExpanded ? 'ChevronUp' : 'ChevronDown'}
        iconPosition="right"
        className="w-full justify-center text-muted-foreground hover:text-foreground"
      >
        Demo Credentials
      </Button>
      {isExpanded && (
        <div className="mt-4 p-4 bg-muted/50 rounded-lg border border-border">
          <p className="text-xs text-muted-foreground mb-3 text-center">
            Use these credentials to explore different user roles
          </p>
          
          <div className="space-y-3">
            {mockAccounts?.map((account, index) => (
              <div key={index} className="bg-card p-3 rounded-md border border-border">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-xs font-medium text-foreground">
                    {account?.role}
                  </span>
                  <span className="text-xs px-2 py-0.5 rounded-full bg-primary/10 text-primary font-medium">
                    {account?.badge}
                  </span>
                </div>
                
                <div className="space-y-1">
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-muted-foreground">Email:</span>
                    <div className="flex items-center space-x-1">
                      <span className="text-xs font-mono text-foreground">
                        {account?.email}
                      </span>
                      <button
                        onClick={() => copyToClipboard(account?.email, 'email')}
                        className="p-1 hover:bg-muted rounded transition-colors"
                        title="Copy email"
                      >
                        <Icon 
                          name={copiedItem === `${account?.email}-email` ? 'Check' : 'Copy'} 
                          size={12} 
                          className={copiedItem === `${account?.email}-email` ? 'text-green-500' : 'text-muted-foreground'}
                        />
                      </button>
                    </div>
                  </div>
                  
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-muted-foreground">Password:</span>
                    <div className="flex items-center space-x-1">
                      <span className="text-xs font-mono text-foreground">
                        {account?.password}
                      </span>
                      <button
                        onClick={() => copyToClipboard(account?.password, 'password')}
                        className="p-1 hover:bg-muted rounded transition-colors"
                        title="Copy password"
                      >
                        <Icon 
                          name={copiedItem === `${account?.password}-password` ? 'Check' : 'Copy'} 
                          size={12} 
                          className={copiedItem === `${account?.password}-password` ? 'text-green-500' : 'text-muted-foreground'}
                        />
                      </button>
                    </div>
                  </div>
                </div>
                
                <p className="text-xs text-muted-foreground mt-2 italic">
                  {account?.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default MockCredentialsHelper;